import { render, staticRenderFns } from "./CFG.vue?vue&type=template&id=34590e4b&scoped=true"
import script from "./CFG.vue?vue&type=script&lang=js"
export * from "./CFG.vue?vue&type=script&lang=js"
import style0 from "./CFG.vue?vue&type=style&index=0&id=34590e4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34590e4b",
  null
  
)

export default component.exports